(() => {
  const SELECTOR = "[data-peguu-materials]";

  const escapeHtml = (value) => {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  };

  const createSlug = (value) => {
    return String(value ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

  const getDiscountPercentage = (value) => {
    const percentage = Number(value);

    if (!Number.isFinite(percentage) || percentage <= 0) {
      return 0;
    }

    return percentage;
  };

  const isValidImageUrl = (value) => {
    try {
      const url = new URL(value);

      return (
        url.protocol === "https:" ||
        url.protocol === "http:"
      );
    } catch {
      return false;
    }
  };

  const createCard = (material) => {
    const article = document.createElement("article");
    article.className = "peguu-material-card";

    const materialSlug = createSlug(material.name);

    const materialUrl =
      `/pages/material-detalle?material=${encodeURIComponent(
        materialSlug
      )}`;

    const materialName = escapeHtml(
      material.name || "Material"
    );

    const materialId = escapeHtml(
      material.id || ""
    );

    const productCode = escapeHtml(
      material.productCode || ""
    );

    const discountPercentage =
      getDiscountPercentage(material.discountPercent);

    const isTopSeller =
      material.isTopSeller === true;

    const hasDiscount =
      discountPercentage > 0;

    const imageUrl = isValidImageUrl(material.imageUrl)
      ? escapeHtml(material.imageUrl)
      : "";

    const badges = [];

    /*
      Solo aparece cuando la API manda:
      isTopSeller: true
    */
    if (isTopSeller) {
      badges.push(`
        <span
          class="
            peguu-material-card__badge
            peguu-material-card__badge--top
          "
        >
          Más vendido
        </span>
      `);
    }

    /*
      Solo aparece cuando la API manda un valor
      mayor que cero en discountPercent.
    */
    if (hasDiscount) {
      badges.push(`
        <span
          class="
            peguu-material-card__badge
            peguu-material-card__badge--discount
          "
          title="${discountPercentage}% de descuento"
        >
          En oferta
        </span>
      `);
    }

    article.innerHTML = `
      <a
        class="peguu-material-card__link"
        href="${materialUrl}"
        aria-label="Seleccionar ${materialName}"
        data-material-link
      >

        <div class="peguu-material-card__media">

          ${
            badges.length
              ? `
                <div class="peguu-material-card__badges">
                  ${badges.join("")}
                </div>
              `
              : ""
          }

          <div class="peguu-material-card__image-wrap">
            ${
              imageUrl
                ? `
                  <img
                    class="peguu-material-card__image"
                    src="${imageUrl}"
                    alt="${materialName}"
                    width="282"
                    height="275"
                    loading="lazy"
                    decoding="async"
                  >
                `
                : `
                  <span class="peguu-material-card__no-image">
                    Imagen no disponible
                  </span>
                `
            }
          </div>
        </div>

        <span
          class="peguu-material-card__button"
          aria-hidden="true"
          data-material-button
          data-material-id="${materialId}"
          data-product-code="${productCode}"
        >
          <svg
            width="26"
            height="23"
            viewBox="0 0 26 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M14.153 22.4275L13.2109 20.9627C18.4643 17.3466 22.2436 12.4717 23.4295 10.8467C18.6859 5.5141 13.621 1.22282 12.6457 1.76066C12.0805 2.75624 13.7873 5.67431 18.8189 9.79395C19.2401 10.1373 19.4063 10.7209 19.229 11.2473C19.0517 11.7737 18.5862 12.117 18.0542 12.117C16.1147 12.117 6.13998 11.9453 0 8.54661L0.797976 7.00175C5.71883 9.72529 13.621 10.2402 16.7797 10.3432C13.2109 7.27639 9.74196 3.40851 11.1606 0.902402C11.4487 0.387448 11.9364 0.0670317 12.5238 0.00981452C15.7711 -0.333488 23.6179 8.43218 25.1584 10.1945L25.6128 10.7094L25.236 11.2816C25.0587 11.5448 20.8139 17.8501 14.1641 22.4275H14.153Z"
              fill="currentColor"
            />
          </svg>
        </span>

        <h2 class="peguu-material-card__name">
          ${materialName}
        </h2>
      </a>
    `;

    const link = article.querySelector(
      "[data-material-link]"
    );

    const storeSelectedMaterial = () => {
      const selectedMaterial = {
        id: material.id || "",
        name: material.name || "",
        slug: materialSlug,
        productCode: material.productCode || "",
        imageUrl: material.imageUrl || "",
        discountPercent: getDiscountPercentage(
            material.discountPercent
        )
      };

      try {
        sessionStorage.setItem(
          "peguu:selected-material",
          JSON.stringify(selectedMaterial)
        );
      } catch (error) {
        console.warn(
          "No fue posible guardar temporalmente el material:",
          error
        );
      }
    };

    if (link) {
      link.addEventListener(
        "click",
        storeSelectedMaterial
      );

      link.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") {
          return;
        }

        event.preventDefault();
        link.click();
      });
    }

    return article;
  };

  const loadMaterials = async (section, options = {}) => {
    const force = options.force === true;

    if (
      !force &&
      section.dataset.materialsInitialized === "true"
    ) {
      return;
    }

    section.dataset.materialsInitialized = "true";

    const apiUrl = window.PeguuApi.resolve(
      section.dataset.apiUrl
    );

    const grid = section.querySelector(
      "[data-materials-grid]"
    );

    const status = section.querySelector(
      "[data-materials-status]"
    );

    if (!apiUrl || !grid || !status) {
      return;
    }

    try {
      const receivedMaterials =
        await window.PeguuMaterials.getMaterials({
          url: apiUrl,
          force
        });

      /*
        Solo se muestran los materiales activos.

        No los reordenamos.
        Se respeta el orden enviado por la API.
      */
      const materials = receivedMaterials.filter(
        (material) => material?.active === true
      );

      grid.replaceChildren();

      if (!materials.length) {
        status.textContent =
          "Por el momento no hay materiales disponibles.";

        status.hidden = false;
        return;
      }

      const fragment =
        document.createDocumentFragment();

      materials.forEach((material) => {
        fragment.appendChild(
          createCard(material)
        );
      });

      grid.appendChild(fragment);
      status.hidden = true;
    } catch (error) {
      console.error(
        "No fue posible cargar los materiales:",
        error
      );

      grid.replaceChildren();

      status.innerHTML = `
        <p>No pudimos cargar los materiales</p>
        <button
          type="button"
          class="peguu-materials__retry"
          data-materials-retry
        >
          Reintentar
        </button>
      `;

      status.hidden = false;

      const retryButton = status.querySelector(
        "[data-materials-retry]"
      );

      retryButton?.addEventListener("click", () => {
        retryButton.disabled = true;
        loadMaterials(section, { force: true });
      });
    }
  };

  const initializeAll = (container = document) => {
    container
      .querySelectorAll(SELECTOR)
      .forEach(loadMaterials);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      if (!section) {
        return;
      }

      section.dataset.materialsInitialized = "false";
      loadMaterials(section);
    }
  );
})();
